import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IClassroomsPayload,IInitialStateClassrooms} from "../types";
import {GetClassrooms, GetDeleteClassrooms} from "./thunk";



const initialState:IInitialStateClassrooms = {
    classrooms:[],
    classroomsRestore:[],
    isViewClassroomsRestore:false,
    isLoadingClassrooms:true,
    selectedClassroomsIDs:[]
}

const classroomsSlice = createSlice({
    name:"classrooms",
    initialState,
    reducers:{
        setClassrooms: (state, action: PayloadAction<IClassroomsPayload[]>) => {
            state.classrooms = action.payload
        },
        deletedClassrooms: (state, action: PayloadAction<number>) => {
            const updateData = action.payload;
            state.classrooms = state.classrooms.filter((elem) => elem.id !== updateData)
        },
        updateClassrooms: (state, action: PayloadAction<IClassroomsPayload>) => {
            const updateData = action.payload;
            state.classrooms = state.classrooms.map((elem) => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData
                    };
                }
                return elem;
            });
        },
        setClassroomsRestore: (state, action) => {
            state.classroomsRestore = action.payload;
        },
        deletedRestoreClassrooms: (state, action) => {
            const id = action.payload
            state.classroomsRestore = state.classroomsRestore.filter(
                (elem) => elem.id !== id
            );
        },
        setIsViewClassroomsRestore: (state) => {

            state.isViewClassroomsRestore = !state.isViewClassroomsRestore;
        },
        setSelectedClassroomsIDs: (state, action) => {
            state.selectedClassroomsIDs = action.payload
        },

    },
    extraReducers: (builder) => {
        builder.addCase(GetClassrooms.pending, state => {
            state.isLoadingClassrooms = true
        }).addCase(GetClassrooms.fulfilled, state => {
            state.isLoadingClassrooms = false
        }).addCase(GetClassrooms.rejected, state => {
            state.isLoadingClassrooms = false
        })
            .addCase(GetDeleteClassrooms.pending, state => {
                state.isLoadingClassrooms = true
            }).addCase(GetDeleteClassrooms.fulfilled, state => {
            state.isLoadingClassrooms = false
        }).addCase(GetDeleteClassrooms.rejected, state => {
            state.isLoadingClassrooms = false
        })
    }

})


export const  {
    setSelectedClassroomsIDs,
    deletedClassrooms,
    setIsViewClassroomsRestore,
    deletedRestoreClassrooms,
    setClassroomsRestore,
    updateClassrooms,
    setClassrooms
} =classroomsSlice.actions

export default classroomsSlice

